<template>
  <div class="m-the-header-sub-menu">
    <ul class="m-the-header-sub-menu-list">
      <!--
      <li>
        <a
          class="a-tooltip-primary a-tooltip-bottom"
          :data-tooltip-text="$t('mTheHeaderSubMenu.tooltipComments')"
          href="#"
          @click.prevent=""
        >
          <i class="fas fa-comment"></i>
        </a>
      </li>
      -->
      <li v-if="false">
        <a
          class="a-tooltip-primary a-tooltip-bottom"
          :data-tooltip-text="$t('mTheHeaderSubMenu.tooltipNotifications')"
          href="#"
          @click.prevent=""
        >
          <i class="fas fa-bell text-color-notifications-primary"></i>
        </a>
      </li>
      <li>
        <div class="m-dropdown-primary">
          <AtomAvatarPrimary
            :avatar-primary="avatarPrimary"
            @switchDropDown="$dropDown.switchDropDown"
          />
          <MoleculeTheHeaderSubMenuDropDownUser :usuario="usuario"/>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'MoleculeTheHeaderSubmenu',

  components: {
    MoleculeTheHeaderSubMenuDropDownUser: () => import('@/components/molecules/MoleculeTheHeaderSubMenuDropDownUser')
  },

  data () {
    return {
      avatarPrimary: {
        component: 'MoleculeTheHeaderSubMenuDropDownUser',
        image: '',
        method: 'switchDropDown'
      },

      showLoadingState: false
    }
  },

  computed: {
    usuario () {
      return this.$store.getters.getUserData
    }
  },

  watch: {
    usuario: {
      deep: true,

      handler () {
        this.avatarPrimary.image = this.usuario.vidroop_data
          ? this.usuario.vidroop_data.avatar
          : this.usuario.picture
            ? this.usuario.picture
            : ''
      },

      immediate: true
    }
  }
}
</script>
